import React, { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { confirmPasswordReset } from "../api_controll/apiAdmin";
import { toast } from "react-toastify";
import "../styles/auth-password.css";

export default function ResetPasswordPage() {
  const location = useLocation();

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("token") || "";
  }, [location.search]);

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [formError, setFormError] = useState(null);

  const handleSubmit = async () => {
    setFormError(null);

    if (!token) {
      setFormError("Chybí resetovací token.");
      return;
    }

    if (password.length < 8) {
      setFormError("Heslo musí mít alespoň 8 znaků.");
      return;
    }

    if (password !== passwordAgain) {
      setFormError("Hesla se neshodují.");
      return;
    }

    try {
      setLoading(true);

      await confirmPasswordReset({
        token,
        password,
      });

      setDone(true);
      setPassword("");
      setPasswordAgain("");
    } catch (e) {
      toast.error("Odkaz je neplatný nebo expirovaný.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Nastavení hesla</h2>

        {done ? (
          <>
            <div className="auth-card__success">
              Heslo bylo úspěšně nastaveno. Nyní se můžete přihlásit novým heslem.
            </div>

            <Link className="auth-card__buttonLink" to="/">
              Přejít na přihlášení
            </Link>
          </>
        ) : (
          <>
            <div className="auth-card__password-rules">
              Heslo musí mít alespoň 8 znaků.
            </div>

            {formError && (
              <div className="auth-card__error">
                {formError}
              </div>
            )}

            <div className="auth-card__field">
              <label htmlFor="new-password">Nové heslo</label>
              <input
                id="new-password"
                type="password"
                placeholder="Nové heslo"
                autoComplete="new-password"
                value={password}
                disabled={loading}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="auth-card__field">
              <label htmlFor="new-password-again">Nové heslo znovu</label>
              <input
                id="new-password-again"
                type="password"
                placeholder="Nové heslo znovu"
                autoComplete="new-password"
                value={passwordAgain}
                disabled={loading}
                onChange={(e) => setPasswordAgain(e.target.value)}
              />
            </div>

            <button type="button" onClick={handleSubmit} disabled={loading}>
              {loading ? "Ukládám…" : "Nastavit heslo"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}